var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show_pi_indicator)?_c('Icon',{directives:[{name:"tooltip",rawName:"v-tooltip:top.points",arg:"top",modifiers:{"points":true}}],attrs:{"icon":"SPIMarker","tooltip-data":_vm.labels}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }